import React, { useState, useRef } from 'react';
import ReactDOM from "react-dom";
import Card from "../components/Card";
import SearchInput from "../components/datatable/SearchInput"
import AjaxDynamicDataTable from '@langleyfoxall/react-dynamic-data-table/dist/AjaxDynamicDataTable';
import LoadingIndicator from "../components/datatable/LoadingIndicator";
import EmptyTable from "../components/datatable/EmptyTable";
import Filter from "../components/datatable/Filter";
import Button from "../components/Button";
import DateInput from '../components/forms/inputs/DateInput';

const FILTER_OPTIONS = {
    all: {
        name:   'All',
        value:  'all',
    },
    not_scheduled: {
        name:   'Not Scheduled',
        value:  'not_scheduled',
    },
    scheduled: {
        name:   'Scheduled',
        value:  'scheduled',
    },
    pending_collection: {
        name:   'Pending Collection',
        value:  'pending_collection',
    },
    delivered: {
        name:   'Delivered',
        value:  'delivered',
    },
    archived: {
        name:   'Archived',
        value:  'archived',
    },
}

const OverviewDeliveryDataTable = (props) => {
    const {
        jobTypes,
        users,
    } = props;

    const dataTableRef                          = useRef(null);
    const [search, setSearch]                   = useState("");
    const [statusFilter, setFilter]             = useState(FILTER_OPTIONS.all.value);
    const [jobTypeFilter, setJobTypeFilter]     = useState(null);
    const [userFilter, setUserFilter]           = useState(null);

    const renderRowButton = (delivery) => {
        return (
            <td>
                <div className={"d-flex justify-content-end align-content-center align-items-center"}>
                    {!!delivery.can && delivery.can.view === true && delivery.deleted_at === "-" && (
                        <a className="text-primary cursor-pointer" href={route('job.order.delivery.edit', {job: delivery.job_id, order: delivery.order_id, delivery: delivery.id}).toString()}>
                            View
                        </a>
                    )}
                </div>
            </td>
        )
    }

    return (
        <React.Fragment>
            <Card classes={"border-0"} noPadding={true}>
                <div className="row">
                    <div className="col-12 col-xl-3 mb-3">
                        <SearchInput
                            value={search}
                            classes={""}
                            placeholder={"Search..."}
                            onChange={(value) => setSearch(value)}
                        />
                    </div>
                    <Filter
                        label={"Status:"}
                        value={statusFilter}
                        options={Object.values(FILTER_OPTIONS)}
                        name={"filter_status"}
                        onChange={(value) => setFilter(value)}
                        classes={"col-12 col-xl-2 mb-3"}
                    />
                    <Filter
                        label={"Job Type:"}
                        value={jobTypeFilter}
                        options={jobTypes}
                        name={"filter_job_type"}
                        onChange={(value) => setJobTypeFilter(value)}
                        classes={"col-12 col-xl-2 mb-3"}
                    />
                    <Filter
                        label={"User:"}
                        value={userFilter}
                        options={users}
                        name={"filter_user"}
                        onChange={(value) => setUserFilter(value)}
                        classes={"col-12 col-xl-2 mb-3"}
                    />
                    <div className="col-1"></div>
                    {can('create', 'job') && (
                        <div className="col-2 col-xs-4 float-right mb-3">
                            <Button
                                href={route('job.create', {origin: "overview-delivery"}).toString()}
                                label={"Create Job"}
                                icon={"far fa-plus-circle"}
                                classes={"btn btn-eh-lilac px-3 justify-content-center"}
                            />
                        </div>
                    )}
                </div>
                <div className={"row m-0 p-0"}>
                    <div className={"col-12 m-0 p-0"}>
                        <div className="data-table">
                            <AjaxDynamicDataTable
                                apiUrl={route('web-api.overview.delivery.data-table').toString()}
                                loadingComponent={<LoadingIndicator />}
                                noDataComponent={<EmptyTable itemName="deliveries" />}
                                fieldsToExclude={statusFilter === FILTER_OPTIONS.archived.value ? [
                                    'job_id',
                                    'created_at',
                                    'can',
                                ] : [
                                    'job_id',
                                    'created_at',
                                    'deleted_at',
                                    'can',
                                ]}
                                alwaysShowPagination
                                fieldOrder={[
                                    "id",
                                    "order_id",
                                    "job_name",
                                    "job_type",
                                    "customer_name",
                                    "delivery_at",
                                    "products_count",
                                    "user_name",
                                    "status",
                                    "deleted_at"
                                ]}
                                fieldMap={{
                                    id:             "Delivery Ref",
                                    order_id:       "Order Ref",
                                    job_name:       "Job Name",
                                    job_type:       "Type",
                                    customer_name:  "Customer",
                                    delivery_at:    "Delivery Date",
                                    products_count: "Products",
                                    user_name:      "Driver Assigned",
                                    status:         "Status",
                                    deleted_at:     "Date Archived",
                                }}
                                ref={dataTableRef}
                                defaultOrderByField={'delivery_at'}
                                defaultOrderByDirection={'desc'}
                                params={{
                                    searchTerm: search,
                                    statusFilter: statusFilter,
                                    jobTypeFilter: jobTypeFilter,
                                    userFilter: userFilter,
                                }}
                                buttons={(row) => renderRowButton(row)}
                                dataItemManipulator={(field, value, row) => {
                                    switch (field) {
                                        case 'status':
                                            return (
                                                <span className={"text-eh-light-blue font-weight-bold"}>{value}</span>
                                            );
                                    }

                                    return <span>{value}</span>;
                                }}
                            />
                        </div>
                    </div>
                </div>
            </Card>
        </React.Fragment>
    );
}

export default OverviewDeliveryDataTable;

const target = document.getElementById('overview-delivery-datatable');
if (target) {
    ReactDOM.render(
        <OverviewDeliveryDataTable
            jobTypes={JSON.parse(target.dataset.jobTypes)}
            users={JSON.parse(target.dataset.users)}
        />,
        target
    );
}
